<template>
    <div data-qa-id="blur-bundles" class="fou-promotion">
      <div
        v-for="(bundle , index) in BUNDLES"
        :key="index"
        data-qa-id="bundle-list"
        class="fou-promotion__list"
      >
        <span data-qa-id="bundle-title" class="fou-promotion__list__name is-blur is-blur--less">{{ bundle.bundleTitle }}</span>
        <div data-qa-id="individual-bundle" class="fou-promotion__list__desc is-blur is-blur--less">
          <span data-qa-id="title"> {{ bundle.expire }} </span>
          <link-arrow data-qa-id="icon" class="promotion-arrow" />
        </div>
      </div>
      <div data-qa-id="footer" class="footer-section">
        <button data-qa-id="create-bundle-navigation" class="promotion-btn--primary btn--disabled" disabled>
          <percentage-star class="percentage-star" />{{ $t('pages.dashboard.components.bundle.new_bundle') }}
        </button>
        <button data-qa-id="all-bundle-navigation" class="promotion-btn--secondary btn--disabled" disabled>
          {{ $t('pages.dashboard.components.bundle.all_bundle') }}
          <link-arrow class="ml-11" fill-color="#C3CAD4" />
        </button>
      </div>
    </div>
  </template>
  
  <script src="./script" />